import { gql } from '@apollo/client';
import { mutate } from '../../../../../../common/graphql';
import { RevenueShareInputV3 } from '@crazygames/graph-types/revenue/revenue-share-v3.type';

const DEVELOPER_SUBMISSION_UPDATE_LEGAL_FORM = gql`
  mutation developerSubmissionUpdateLegalForm($input: DeveloperSubmissionUpdateLegalFormInput!) {
    developerSubmissionUpdateLegalForm(input: $input) {
      id
    }
  }
`;

export interface UpdateLegalFormMutation {
  developerSubmissionUpdateLegalForm: { id: string };
}

export interface UpdateLegalFormMutationInput {
  id: string;
  revenueShareInputV3: RevenueShareInputV3;
}

export function developerSubmissionUpdateLegalForm(input: UpdateLegalFormMutationInput) {
  return mutate<UpdateLegalFormMutationInput, UpdateLegalFormMutation>(DEVELOPER_SUBMISSION_UPDATE_LEGAL_FORM, input);
}
